import { DateTime } from 'luxon'
import { Component } from 'preact'
import classNames from 'classnames'

import styles from './styles/app-bar.css'

class AppBar extends Component {
  state = {
    time: DateTime.local(),
  }

  componentDidMount() {
    this.intervalId = setInterval(() => {
      this.setState({
        time: DateTime.local(),
      })
    }, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
  }

  render({ title, subtitle, className, text }) {
    const appBarClasses = classNames(styles['app-bar__wrap'], className, {
      [styles['text--center']]: text === 'center',
    })

    return (
      <div className={styles.appBarComponent}>
        <div className={appBarClasses}>
          <div className={styles.title}>{title}</div>

          <div className={styles.clock}>
            {this.state.time.toLocaleString(DateTime.TIME_SIMPLE)}
          </div>
        </div>
        {subtitle && <div className={styles.subtitle}>{subtitle ? subtitle : ''}</div>}
      </div>
    )
  }
}

export default AppBar
